/*
 |------------------------------------------------------------------------------
 | Storage manager
 |------------------------------------------------------------------------------
 |
 | A set of helpers to work with localStorage, sessionStorage & cookies
 |
 */

export function getSessionStorage(name) {
	return JSON.parse(window.sessionStorage.getItem(name));
}

export function setSessionStorage(name, data) {
	window.sessionStorage.setItem(name, JSON.stringify(data));
}

/* ========================================================================== */

export function getLocalStorage(name) {
	return JSON.parse(window.localStorage.getItem(name));
}

export function setLocalStorage(name, data) {
	window.localStorage.setItem(name, JSON.stringify(data));
}

/* ========================================================================== */

export function getCookie(name) {
	const cname = name + '=',
		decodedCookie = decodeURIComponent(document.cookie),
		ca = decodedCookie.split(';');

	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(cname) == 0) {
			return c.substring(cname.length, c.length);
		}
	}
	return '';
}
